import { Flame, CalendarDays, GitCommit, Trophy } from 'lucide-react';
import { COMMIT_COUNTS } from './data';

// ---------------------------------------------------------------------------
// Compute stats from COMMIT_COUNTS
// ---------------------------------------------------------------------------

function computeStats() {
  const dates = Object.keys(COMMIT_COUNTS).sort();

  const totalCommits = Object.values(COMMIT_COUNTS).reduce((a, b) => a + b, 0);
  const activeDays = dates.length;

  // Streak computation — find longest consecutive run
  let maxStreak = 0;
  let currentStreak = 0;
  let prevDate: Date | null = null;

  for (const iso of dates) {
    const d = new Date(iso + 'T12:00:00');
    if (prevDate) {
      const diffDays = Math.round(
        (d.getTime() - prevDate.getTime()) / 86400000
      );
      if (diffDays === 1) {
        currentStreak++;
      } else {
        currentStreak = 1;
      }
    } else {
      currentStreak = 1;
    }
    if (currentStreak > maxStreak) maxStreak = currentStreak;
    prevDate = d;
  }

  // Current streak — count backwards from today / last entry
  const lastDate = new Date(dates[dates.length - 1] + 'T12:00:00');
  let streak = 0;
  let check = lastDate;
  while (true) {
    const iso = check.toISOString().slice(0, 10);
    if (COMMIT_COUNTS[iso] !== undefined) {
      streak++;
      check = new Date(check.getTime() - 86400000);
    } else {
      break;
    }
  }

  return { totalCommits, activeDays, currentStreak: streak, allTimeRecord: maxStreak };
}

const STATS = computeStats();

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

interface StatCardProps {
  icon: React.ReactNode;
  value: string;
  label: string;
}

function StatCard({ icon, value, label }: StatCardProps) {
  return (
    <div className="flex flex-1 items-center gap-3 rounded-lg border border-border bg-muted/40 px-4 py-3">
      <div className="shrink-0 text-muted-foreground">{icon}</div>
      <div className="min-w-0">
        <div className="text-lg font-bold leading-none text-foreground">
          {value}
        </div>
        <div className="mt-0.5 text-xs text-muted-foreground">{label}</div>
      </div>
    </div>
  );
}

export function StatsBar() {
  return (
    <div className="flex flex-wrap gap-2">
      <StatCard
        icon={<Flame className="h-4 w-4" />}
        value={`${STATS.currentStreak} days`}
        label="Current streak"
      />
      <StatCard
        icon={<Trophy className="h-4 w-4" />}
        value={`${STATS.allTimeRecord} days`}
        label="All-time record"
      />
      <StatCard
        icon={<CalendarDays className="h-4 w-4" />}
        value={String(STATS.activeDays)}
        label="Active days"
      />
      <StatCard
        icon={<GitCommit className="h-4 w-4" />}
        value={String(STATS.totalCommits)}
        label="Total commits"
      />
    </div>
  );
}
